import enquire from 'enquire.js';
const InitGlobal = () => {
  const body = document.body;
  const menuToggle = document.querySelector('.menu-toggle');
  const initEnquirePc = () => {
    window.deviceSize = 'pc';
    if (body.classList.contains('is-menu-open')) {
      menuToggle.click();
    }
  };
  const initEnquireMobile = () => {
    window.deviceSize = 'mobile';
  };
  const initEnquire = () => {
    body.classList.remove('is-loading');
    enquire.register('screen and (max-width:1023px)', {
      match: () => {
        window.isMobile = true;
        body.classList.add('is-mobile');
        body.classList.remove('is-pc');
        initEnquireMobile();
      },
      unmatch: () => {
        window.isMobile = false;
        body.classList.remove('is-mobile');
        body.classList.add('is-pc');
        initEnquirePc();
      },
    });
  };
  const initResize = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--vh', `${window.innerHeight}px`);
  };

  window.addEventListener('resize', initResize);

  window.addEventListener('DOMContentLoaded', (event) => {
    initResize();
    initEnquire();
  });
};
export default InitGlobal;
